export default __webpack_public_path__ + "static/media/svg-6.c5fd05b0.svg";